export default {
  button: {
    gutter: 8,
  },
}
